<div
  class="component-container"
  data-cy="won_message"
  [style.backgroundColor]="config().backgroundColor"
>
  <div class="image-container">
    <img
      class="morission-picture"
      [src]="config().morissonPicture.imageUrl"
      [alt]="config().morissonPicture.alternativeText"
    />
    <img
      class="completed-picture"
      [src]="config().completedPicture.imageUrl"
      [alt]="config().completedPicture.alternativeText"
    />
  </div>

  <div
    class="amount-container"
    [innerHTML]="config().amountTemplate | replaceVars: amount() | safe"
  ></div>
</div>
